//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IconWithDetailToTop from "@/components/objects/public/attrs/icons/items/IconWithDetailToTop.vue";
import TheBlockHeader from "@/components/TheBlockHeader.vue";
import { DesignExtra } from "@/utils/dto/objects.js";
import { adjustColorBrightness } from "@/utils/helpers.js";

export default {
  name: "IconAttrWithDetailToTop",
  components: { TheBlockHeader, IconWithDetailToTop },
  inject: {
    specialProject: {
      default: false
    }
  },
  props: {
    items: {
      type: Array,
      default: () => {
        return []
      }
    },
    objectId: {
      type: String,
      default: ''
    },
    listInfo: {
      type: Object,
      default: null
    },
    useStorage: {
      type: Boolean,
      default: false
    },
    design: {
      type: String,
    },
    template: {
      type: Object,
    },
    user: {
      type: Object,
      default: () => {}
    },
    design_extra: {
      type: [Object, DesignExtra],
      default: () => {}
    },
  },
  data() {
    return {
      detail: false,
      isMobile: false,
      expandId: '',
      changeDesignToggle: false,
    }
  },
  computed: {
    rowSize() {
      return this.detail ? 2 : 3
    },
    processedItems() {
      const TOTAL = this.items.length

      return this.items.map((item, index) => {
        return {
          data: item,
          direction: this.computeLayout(TOTAL, index)
        }
      })
    },
    getBlockName() {
      return this.getImageType ? 'links' + '_' + this.getImageType : 'links'
    },
    getImageType() {
      return this.items[0]?.image_type === 'image' ? 'images' : 'icons'
    },
    paletteList() {
      return this.$store.state["property_templates"]["consts"].palette;
    },
    bgPalette() {
      if (this.design_extra?.bg?.palette && this.paletteList) {
        return this.paletteList.filter(el => el.id === this.design_extra.bg.palette)[0];
      }

      return null;
    },
    iconBorderPalette() {
      if (this.design_extra?.icon_border?.palette && this.paletteList) {
        return this.paletteList.filter(el => el.id === this.design_extra.icon_border.palette)[0];
      }

      return null;
    },
    iconBgPalette() {
      if (this.design_extra?.icon_bg?.palette && this.paletteList) {
        return this.paletteList.filter(el => el.id === this.design_extra.icon_bg.palette)[0];
      }

      return null;
    },
    getTextColor() {
      return this.design_extra?.text?.color ?? null;
    },
    getIconColor() {
      return this.design_extra?.icon_color?.color ?? 'vistat';
    },
    getMask() {
      return this.design_extra?.mask?.name ?? null;
    },
    // getFirstBlockArrowBg() {
    //   if (this.getFirstBlockBgGradientEnabled) {
    //     if (this.getBgGradientDirection === 'left' || this.getBgGradientDirection === 'right') {
    //       return this.getFirstBlockBg;
    //     } else if (this.getBgGradientDirection === 'top') {
    //       return `${this.getBgGradientShadowDirection === 'transparent' ? this.getFirstBlockBgColor : adjustColorBrightness((this.getFirstBlockBgColor), 1.20) }`
    //     } else {
    //       return `${this.getBgGradientShadowDirection === 'transparent' ? 'transparent' : adjustColorBrightness((this.getFirstBlockBgColor), 1.20) }`
    //     }
    //   } else if (this.design_extra?.first_block?.gradient_enabled && this.design_extra?.first_block?.bg_color) {
    //     if (this.getFirstBlockBgGradientDirection === 'left' || this.getFirstBlockBgGradientDirection === 'right') {
    //       return this.getFirstBlockBg;
    //     } else if (this.getFirstBlockBgGradientDirection === 'top') {
    //       return `${this.getFirstBlockBgGradientShadowDirection === 'transparent' ? this.getFirstBlockBgColor : adjustColorBrightness((this.getFirstBlockBgColor), 1.20) }`
    //     } else {
    //       return `${this.getFirstBlockBgGradientShadowDirection === 'transparent' ? 'transparent' : adjustColorBrightness((this.getFirstBlockBgColor), 1.20) }`
    //     }
    //   }

    //   return this.getFirstBlockBgColor;
    // },
    getFirstBlockBg() {
      if (this.getFirstBlockBgGradientEnabled) {
        return `linear-gradient(to ${this.getBgGradientDirection}, ${this.getBgGradientShadowDirection === 'transparent' ? `${this.getFirstBlockBgColor}, transparent` : `${this.getFirstBlockBgColor}, ${adjustColorBrightness((this.getFirstBlockBgColor), 1.20)}`})`
      } else if (this.design_extra?.first_block?.gradient_enabled && this.design_extra?.first_block?.bg_color) {
        return `linear-gradient(to ${this.getFirstBlockBgGradientDirection}, ${this.getFirstBlockBgGradientShadowDirection === 'transparent' ? `${this.getFirstBlockBgColor}, transparent` : `${this.getFirstBlockBgColor}, ${adjustColorBrightness((this.getFirstBlockBgColor), 1.20)}`})`
      }

      return this.getFirstBlockBgColor;
    },
    getFirstBlockBgColor() {
      return this.design_extra?.first_block?.bg_color ?? this.getBgColor(0) ?? null;
    },
    getFirstBlockBgGradientEnabled() {
      if (this.hasNotFirstBlockBgAndHasBgPalette) {
        return this.design_extra?.bg?.gradient_enabled ?? null;
      } else {
        return this.design_extra?.first_block?.gradient_enabled ?? null;
      }
    },
    getFirstBlockBgGradientDirection() {
      if (this.hasNotFirstBlockBgAndHasBgPalette) {
        return this.design_extra?.bg?.gradient_direction ?? null;
      } else {
        return this.design_extra?.first_block?.gradient_direction ?? null;
      }
    },
    getFirstBlockBgGradientShadowDirection() {
      if (this.hasNotFirstBlockBgAndHasBgPalette) {
        return this.design_extra?.bg?.gradient_shadow_direction ?? null;
      } else {
        return this.design_extra?.first_block?.gradient_shadow_direction ?? null;
      }
    },
    getFirstBlockTitleColor() {
      return this.design_extra?.first_block?.title_color ?? '#D7F1FF' ?? null;
    },
    getBgGradientEnabled() {
      return this.design_extra?.bg?.gradient_enabled ?? null;
    },
    getBgGradientDirection() {
      return this.design_extra?.bg?.gradient_direction ?? null;
    },
    getBgGradientShadowDirection() {
      return this.design_extra?.bg?.gradient_shadow_direction ?? null;
    },
    getIconGradientEnabled() {
      return this.design_extra?.icon_bg?.gradient_enabled ?? null;
    },
    getIconGradientDirection() {
      return this.design_extra?.icon_bg?.gradient_direction ?? null;
    },
    getIconGradientShadowDirection() {
      return this.design_extra?.icon_bg?.gradient_shadow_direction ?? null;
    },
    hasNotFirstBlockBgAndHasBgPalette() {
      if (!this.design_extra?.first_block?.bg_color && this.bgPalette) {
        return true;
      } else return false;
    },
  },
  mounted() {
    window.addEventListener('resize', this.resizeHandler, { passive: true })

    setTimeout(function(){
      const resizeEvent = new Event('resize');
      window.dispatchEvent(resizeEvent);
    }, 2000);
  },
  created() {
    if (process.client) {
      this.resizeHandler()
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeHandler)
  },
  methods: {
    async onDetailInput(evt) {
      this.detail = typeof evt === 'boolean' ? evt : !this.detail;

      if (this.template) {
        await this.$store.dispatch('makeRealtimeExample', {
          elementId: 'links-' + this.listInfo.id,
          title: this.listInfo.object_label,
          icon: this.listInfo.icon,
          store: this.$store,
          styles: this.template?.styles,
          headerColumn: this.detail
        })
      }
    },
    getIconBorderColor(index) {
      if (this.iconBorderPalette) {
        return [this.iconBorderPalette.main_color, ...this.iconBorderPalette.colors][index % [this.iconBorderPalette.main_color, ...this.iconBorderPalette.colors].length];
      } else if (this.design_extra?.icon_border?.color) {
        return this.design_extra.icon_border.color
      }

      return null;
    },
    getBgColor(index) {
      if (this.bgPalette) {
        return [this.bgPalette.main_color, ...this.bgPalette.colors][index % [this.bgPalette.main_color, ...this.bgPalette.colors].length];
      } else if (this.design_extra?.bg?.color) {
        return this.design_extra.bg.color
      }

      return null;
    },
    getIconBgColor(index) {
      if (this.getIconGradientEnabled) {
        if (this.iconBgPalette) {
          const color = [this.iconBgPalette.main_color, ...this.iconBgPalette.colors][index % [this.iconBgPalette.main_color, ...this.iconBgPalette.colors].length];
          return `linear-gradient(to ${this.getIconGradientDirection}, ${this.getIconGradientShadowDirection === 'transparent' ? `${color}, transparent` : `${color}, ${adjustColorBrightness(color, 1.20)}`})`
        } else if (this.design_extra?.icon_bg?.color) {
          const color = this.design_extra.icon_bg.color;
          return `linear-gradient(to ${this.getIconGradientDirection}, ${this.getIconGradientShadowDirection === 'transparent' ? `${color}, transparent` : `${color}, ${adjustColorBrightness(color, 1.20)}`})`
        }
      } else {
        if (this.iconBgPalette) {
          return [this.iconBgPalette.main_color, ...this.iconBgPalette.colors][index % [this.iconBgPalette.main_color, ...this.iconBgPalette.colors].length];
        } else if (this.design_extra?.icon_bg?.color) {
          return this.design_extra.icon_bg.color
        }
      }

      return null;
    },
    checkMemberInDominoSequence(number) {
      return (number - 1) % 3 !== 0
    },
    computeLayout(total, index) {
      if (total < 2) {
        return 'to-right'
      }

      if (total % 3 === 0) {
        return this.checkMemberInDominoSequence(index) ? 'to-bottom' : 'to-top'
      }

      if (Math.max(total - 1, 0) % 3 === 0) {
        if (index === 0) return 'to-right'
        return this.checkMemberInDominoSequence(index - 1) ? 'to-bottom' : 'to-top'
      }
      if (Math.max(total - 2, 0) % 3 === 0) {
        if (index === 0 || index + 1 === total) return 'to-right'
        return this.checkMemberInDominoSequence(index - 1) ? 'to-bottom' : 'to-top'
      }

      return 'to-right'
    },
    resizeHandler() {
      this.isMobile = Boolean(window.innerWidth < 640);
    },
    onDesignChange(evt) {
      this.$emit('design-change', evt)
      this.changeDesignToggle = !this.changeDesignToggle
    },
    onTemplateChange(evt) {
      this.$emit('template-change', evt)
      this.changeDesignToggle = !this.changeDesignToggle
    },
    onAttrsFirstWidthChange(evt) {
      this.$refs['attrs-first'].style.setProperty('width', evt + 'px')
    }
  }
}
